import React from 'react'
import PropTypes from 'prop-types'
import { getScript } from '../../utils/utils'

class PickrComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = { pickr: null }
  }

  componentDidMount() {
    getScript('https://cdn.jsdelivr.net/npm/@simonwep/pickr/dist/themes/classic.min.css', 'link').then(async () => {
      await getScript('https://cdn.jsdelivr.net/npm/@simonwep/pickr/dist/pickr.es5.min.js')
      const d = document.querySelector(`div[data-color-id="${this.props.randomid}"]`)
      if (!d) return
      const inputField = d.querySelector('input')
      // eslint-disable-next-line no-undef
      const p = new Pickr({
        el: this.el,
        default: inputField.value || '#000000',
        components: {
          // Main components
          preview: true,
          opacity: true,
          hue: true,
          // Input / output Options
          interaction: {
            hex: true,
            rgba: true,
            hsla: true,
            hsva: true,
            cmyk: true,
            input: true,
            save: true
          }
        }
      })
      p.on('save', color => {
        inputField.value = color.toHEXA()
        this.props.valuechange(`${color.toHEXA()}`)
      })
      this.setState({ pickr: p })
    })
  }

  componentWillUnmount() {
    if (this.state.pickr) this.state.pickr.destroyAndRemove()
  }

  componentDidUpdate() {
    if (this.props.show) {
      if (this.state.pickr) this.state.pickr.show()
      this.props.setshow(false)
    }
  }

  render() {
    const s = this.props.size === 'small' ? '40px' : '55px'
    return <span style={{ height: s, width: s, display: 'inline-block', border: '1px black solid' }}><div ref={el => this.el = el} /></span>
  }
}

PickrComponent.propTypes = {
  randomid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valuechange: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  setshow: PropTypes.func.isRequired,
  size: PropTypes.string
}

export default PickrComponent